import { ENDPOINTS, apiInstance } from '@/shared/api';
import type { ApiResponse, CreditInfoResponse } from '@/shared/api';

export const getCreditInfo = async () => {
  const response = await apiInstance.get<ApiResponse<CreditInfoResponse>>(
    ENDPOINTS.credit.info(),
  );
  if (!response.data) throw new Error('Failed to get credit info');
  return response.data;
};
